import * as React from 'react'
import classNames from 'classnames'

import { Content } from 'sdk/components'

import { Text, TextName } from '../../text/Text'

import classes from './style.module.scss'

interface ComponentProps {
  title: React.ReactNode
  description: React.ReactNode
  actionButton?: React.ReactNode
  imageLink: string
  alignment?: 'center' | 'left'
  videoLink?: string
  className?: string
  mainWrapperClassName?: string
  verticalAlign?: 'bottom' | 'center'
}

export const SimpleTitleButtonHero: React.FC<ComponentProps> = (props) => {
  const {
    title,
    description,
    actionButton,
    imageLink,
    videoLink,
    className,
    alignment,
    mainWrapperClassName,
    verticalAlign,
  } = props

  return (
    <Content
      image={imageLink}
      videoLink={videoLink}
      mainWrapperClassName={classNames(classes.wrapper, mainWrapperClassName)}
      className={classNames(
        classes.container,
        classes[alignment!],
        verticalAlign === 'center' && classes.centered,
        className,
      )}
    >
      <Text
        type={TextName.H1}
        className={classes.heading}
      >
        { title }
      </Text>

      <Text
        type={TextName.Text}
        className={classes.description}
      >
        { description }
      </Text>

      { actionButton && actionButton }
    </Content>
  )
}

SimpleTitleButtonHero.defaultProps = {
  alignment: 'center',
  verticalAlign: 'bottom',
}
